import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SyncService } from './services/sync.service';
import { Constants } from './models/constants';
import { Capacitor } from '@capacitor/core';
import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';
import { SqLiteService} from "./services/sq-lite.service";
import { AuthService } from "./services/auth.service";
import { Network } from '@capacitor/network';
import { timer } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private refreshTokenObservable: any;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    public sync: SyncService,
    private sqLiteService: SqLiteService,
    private authService: AuthService
  ) {
    this.initApp();
  }

  // To check platform is web/mobile by viewport width and initialize SQLite DB
  async ngOnInit() {


  }

  initApp() {
    this.platform.ready().then(() => {

      // Get default language and set it
      let defaultLang = localStorage.getItem(Constants.LANGUAGE) || 'de';
      this.globalize(defaultLang);

      /*
      if (Capacitor.getPlatform() !== 'web') {
        this.sync.remoteDatabase = false;
        this.sqLiteService.initializePlugin().then(() => {
          console.log("Database connection successful!")
        });
      }
       */

      // Refersh token every 5 minutes
      this.refreshToken();

      /*
      Network.addListener('networkStatusChange', status => {
        console.log('Network status changed', status);
      });

      const logCurrentNetworkStatus = async () => {
        const status = await Network.getStatus();

        console.log('Network status:', status);
      };
      */
    })
  }

  /**
   * Refreshes the authentication token at regular intervals to ensure the user session remains active.
   *
   * @return {void} Executes the token load function periodically based on a defined interval.
   */
  async refreshToken() {
    const interval = 1000 * 60 * 5;
    this.refreshTokenObservable = timer(0, interval).subscribe(async (ec) => {
      console.log("Refresh token");
      this.authService.loadToken();
    })
  }



  globalize(selectedLang: string) {
    this.translate.setDefaultLang("de");
    let defaultLangCode = 'de';

    let language = selectedLang;
    if (language === "undefined") {
      language = defaultLangCode;
    }

    this.translate.use(language);
    localStorage.setItem(Constants.LANGUAGE, language);
  }
}
